import { render, staticRenderFns } from "./Inmobiliaria.vue?vue&type=template&id=5ba48993&scoped=true&lang=html&"
import script from "./Inmobiliaria.vue?vue&type=script&lang=js&"
export * from "./Inmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./Inmobiliaria.vue?vue&type=style&index=0&id=5ba48993&prod&lang=css&scoped=true&"
import style1 from "./Inmobiliaria.vue?vue&type=style&index=1&id=5ba48993&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba48993",
  null
  
)

export default component.exports